import { render, staticRenderFns } from "./ChooseConfiguration.vue?vue&type=template&id=58375ff4&scoped=true&"
import script from "./ChooseConfiguration.vue?vue&type=script&lang=js&"
export * from "./ChooseConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ChooseConfiguration.vue?vue&type=style&index=0&id=58375ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58375ff4",
  null
  
)

export default component.exports